var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "23px",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.1437193,11.5000522 L22.0746813,3.5690809 C22.8047359,2.83902547 22.8047359,1.65537479 22.0746813,0.925423797 C21.3446267,0.195368362 20.1610819,0.195368362 19.4310273,0.925423797 L11.4999608,8.85649956 L3.56889438,0.925319354 C2.8388398,0.195263919 1.65529496,0.195263919 0.925240379,0.925319354 C0.195290244,1.65537479 0.195290244,2.83902547 0.925240379,3.56897646 L8.85630683,11.4999478 L0.925240379,19.4310235 C0.195290244,20.161079 0.195290244,21.3447297 0.925240379,22.0746806 C1.65529496,22.8047361 2.8388398,22.8047361 3.56889438,22.0746806 L11.4999608,14.1436049 L19.4310273,22.0746806 C20.1609774,22.8047361 21.3446267,22.8047361 22.0746813,22.0746806 C22.8047359,21.3446252 22.8047359,20.161079 22.0746813,19.4310235 L14.1437193,11.5000522 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop--Watcher",
    transform: "translate(-787.000000, -568.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(16.000000, 193.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(638.000000, 350.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(109.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/close-x",
    transform: "translate(24.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icCloseX",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseX);
export default __webpack_public_path__ + "static/media/icCloseX.139b4be602a492db2de52677adbdf34d.svg";
export { ForwardRef as ReactComponent };